import { useEffect, useState } from "react";
import { REACT_URL, REACT_APP_API } from '../config'
import Preloader from "./Preloader";
import GoodsList from "./GoodsList";
import Cart from "./Cart";
import Basket from "./Basket";
import Alert from "./Alert";

export default function Shop () {
  const [goods, setGoods] = useState([]);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState([]);
  const [isBasketShow, setIsBasketShow] = useState(false);
  const [alertName, setAlertName] = useState('');

  useEffect(function getGoods () {
    fetch(REACT_URL, {
      headers: {
        Authorization: REACT_APP_API
      }
    }).then(res => res.json())
      .then((data) => {
        setGoods(data.shop)
        setLoading(false)
      })
  }, []);

  const addOrder = (item) => {
    const itemIndex = order.findIndex((orderItem) => orderItem.mainId === item.mainId)
    if (itemIndex < 0) {
      const newItem = {
        ...item,
        quantity: 1
      };

      setOrder([...order, newItem]);
    } else {
      const newOrder = order.map((orderItem, index) => {
        if (index === itemIndex) {
          return {
            ...orderItem,
            quantity: orderItem.quantity + 1
          };
        } else {
          return orderItem;
        }
      });
      setOrder(newOrder);
    }
    setAlertName(item.displayName)
  };

  const handleShowBasket = () => {
    setIsBasketShow(!isBasketShow)
  }

  const removeFromBasket = (itemId) => {
    const newOrder = order.filter((el) => el.mainId !== itemId);
    console.log(itemId);
    setOrder(newOrder)
  }

  const incQuantity = (id) => {
    const incOrder = order.map((orderItem) => {
      if (orderItem.mainId === id) {
        return {
          ...orderItem,
          quantity: orderItem.quantity + 1
        };
      }
      else {
        return orderItem
      }
    })
    setOrder(incOrder)
  }

  const decQuantity = (id) => {
    const decOrder = order.map((orderItem) => {
      if (orderItem.mainId === id) {
        return {
          ...orderItem,
          quantity: orderItem.quantity === 0 ? 0 : orderItem.quantity - 1
        };
      }
      else {
        return orderItem
      }
    })
    setOrder(decOrder)
  }

  const closeAlert = () => {
    setAlertName('')
  }

  return (
    <main className='container content'>
      <Cart quantity={order.length} handleShowBasket={handleShowBasket} />
      {
        loading ? <Preloader /> : <GoodsList goods={goods} addOrder={addOrder} />
      }
      {isBasketShow && <Basket order={order}
        handleShowBasket={handleShowBasket}
        removeFromBasket={removeFromBasket}
        incQuantity={incQuantity}
        decQuantity={decQuantity}
      />}
      {
        alertName && <Alert name={alertName} closeAlert={closeAlert} />
      }
    </main>
  )
}